export type ReadOnlyMapT<K, V> = {
  getOrError(key: K, error: string): V | Error;
  getOrDefault(key: K, defaultVaule: V): V;
};

export const ReadOnlyMap = <K, V>(iterable: Iterable<[K, V]>): ReadOnlyMapT<K, V> => {
  const map = new Map(iterable);
  return {
    getOrError: function getOrError(key, error) {
      const value = map.get(key);
      if (value === undefined) return new Error(error);
      return value;
    },
    getOrDefault: function get(key, defaultValue) {
      const value = map.get(key);
      if (value === undefined) return defaultValue;
      return value;
    },
  };
};
